export const modelValues={
    open:"",
    isGutterSheet:false,
    gutterSheetUploadType:null,
    steps:0,
    orderSheetUploadType:null,
    isOrderSheet:false,
  }